import { HelpCircle } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import {
  COMPANY_CLASSIFICATION_GUIDANCE,
  type CompanyClassificationField,
} from "@shared/companyClassificationGuidance";
import { cn } from "@/lib/utils";

interface ClassificationFieldGuideProps {
  field: CompanyClassificationField;
  labelClassName?: string;
  htmlFor?: string;
}

export function ClassificationFieldGuide({
  field,
  labelClassName,
  htmlFor,
}: ClassificationFieldGuideProps) {
  const guidance = COMPANY_CLASSIFICATION_GUIDANCE[field];

  return (
    <div className="space-y-1.5">
      <div className="flex items-center gap-1.5">
        <label htmlFor={htmlFor} className={cn("text-sm font-medium text-muted-foreground", labelClassName)}>
          {guidance.label}
        </label>
        <TooltipProvider delayDuration={150}>
          <Tooltip>
            <TooltipTrigger asChild>
              <button
                type="button"
                className="inline-flex h-4 w-4 items-center justify-center text-muted-foreground/70 hover:text-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-primary"
                aria-label={`Informazioni su ${guidance.label}`}
              >
                <HelpCircle className="h-3.5 w-3.5" />
              </button>
            </TooltipTrigger>
            <TooltipContent className="max-w-xs text-xs leading-5" side="right">
              <p>{guidance.description}</p>
              <p className="mt-1 text-muted-foreground">
                {guidance.cardinality === "single" ? "Un solo valore." : "Sono ammessi più valori."}
              </p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </div>
      <p className="text-xs text-muted-foreground/65" aria-label={`Esempi per ${guidance.label}`}>
        Esempi: {guidance.examples.join(" · ")}
      </p>
    </div>
  );
}
